<template>
  <div>
    <PessoaJuridica
      ref="pessoa_juridica"
      v-model="parceiro.pessoa_juridica"
      :optional-fields="optionalFieldsCNPJ"
    />

    <b-row>
      <b-col cols="12">
        <b-form-group label="Plano Padrão">
          <select-plano v-model="parceiro.plano_padrao_id" />
          <small class="text-gray mb-0 text-wrap">
            O plano que será utilizado por novos clientes deste parceiro
          </small>
        </b-form-group>
        <b-form-group label="IP permitido">
          <b-form-input
            v-model="parceiro.urls[0]"
            name="url"
            type="text"
            placeholder="IP com permissão de acesso"
          >
          </b-form-input>
        </b-form-group>
      </b-col>
      <template v-if="false">
        <b-col cols="12" sm="6">
          <b-form-group label="Situação">
            <b-form-checkbox v-model="parceiro.ativo" switch name="ativo">
              {{ situationLabel }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6">
          <b-form-group label="Login integrado">
            <b-form-checkbox
              v-model="parceiro.login_integrado"
              switch
              name="login_integrado"
            >
              Login integrado
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="6">
          <b-form-group label="Acesso exclusivo">
            <b-form-checkbox v-model="parceiro.apenas_acesso_exclusivo" switch>
              Acesso exclusivo
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>
import PessoaJuridica from "@/components/Form/PessoaJuridica.vue";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import SelectPlano from "@/modules/planos/Components/SelectPlano.vue";
import { mapState } from "vuex";

export default {
  mixins: [validationMixin],
  components: { PessoaJuridica, SelectPlano },
  data: () => ({
    optionalFieldsCNPJ: ["razao_social", "cnpj"],
  }),
  validations: {
    parceiro: {},
  },
  computed: {
    ...mapState("parceiros", ["parceiro"]),
    situationStatus() {
      return this.parceiro.ativo ? "ativo" : "inativo";
    },
    situationLabel() {
      return `Usuário ${this.situationStatus}`;
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.parceiro[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.parceiro.$touch();
      return (
        !this.$v.parceiro.$anyError && this.$refs.pessoa_juridica.isValid()
      );
    },
  },
  created() {},
};
</script>
